<script lang="ts">
    import { moneyFormat } from "../../../helper"
    import { _ } from "svelte-i18n"
    import { normalizeVat } from "../../../../../api/hooks/config-client"

    export let position: OperationPositionOut = null
    export let operation: OperationOut = null
    export let tableRow: {
        sumNetPrice: any
        endCustomerVAT: string
        sumRetailPrice: any
        sumEndCustomerPrice: any
        sumEndCustomerPriceGross: any
        collectionName: string
    } | null = null

    let netPrice: number | undefined
    let grossPrice: number | undefined

    let retailPrice: number | undefined
    let retailPriceGross: number | undefined

    let endCustomerPrice: number
    let endCustomerPriceGross: number

    function getGrossPrice(price: number | undefined, vat: number | string | null | undefined) {
        if (typeof price !== "number") {
            return undefined
        }

        return price * (1 + normalizeVat(vat) / 100)
    }

    if (position && operation) {
        netPrice = position.netPrice
        grossPrice = getGrossPrice(netPrice, operation.endCustomerVAT)
        retailPrice = position.retailPrice
        retailPriceGross = getGrossPrice(retailPrice, operation.endCustomerVAT)
        endCustomerPrice = position.endCustomerPrice
        endCustomerPriceGross = position.endCustomerPriceGross
    } else if (operation) {
        netPrice = operation.sumNetPrice
        grossPrice = getGrossPrice(netPrice, operation.endCustomerVAT)
        retailPrice = operation.sumRetailPrice
        retailPriceGross = getGrossPrice(retailPrice, operation.endCustomerVAT)
        endCustomerPrice = operation.sumEndCustomerPrice
        endCustomerPriceGross = operation.sumEndCustomerPriceGross
    } else if (tableRow) {
        netPrice = tableRow.sumNetPrice
        grossPrice = getGrossPrice(netPrice, tableRow.endCustomerVAT)
        retailPrice = tableRow.sumRetailPrice
        retailPriceGross = getGrossPrice(retailPrice, tableRow.endCustomerVAT)
        endCustomerPrice = tableRow.sumEndCustomerPrice
        endCustomerPriceGross = tableRow.sumEndCustomerPriceGross
    }

    const isOut = () => {
        if (position || operation) {
            return operation.collectionName === "operation-out"
        }
        if (tableRow) {
            return tableRow.collectionName === "operation-out"
        }
        return false
    }
</script>

<div class="table" class:extrawide="{endCustomerPriceGross}">
    <div class="tablerow">
        <div class="col"></div>
        <div class="col alignright small">{$_("positions.net")}</div>
        {#if isOut()}
            <div class="col alignright small">{$_("positions.gross")}</div>
        {/if}
    </div>
    {#if netPrice || grossPrice}
        <div class="tablerow">
            <div class="col alignleft small">{$_("positions.purchasePrice")}</div>
            <div class="col alignright small nowrap">
                {#if netPrice}
                    {moneyFormat(netPrice)}
                {/if}
            </div>
            {#if isOut()}
                <div class="col alignright small nowrap">
                    {#if grossPrice}
                        {moneyFormat(grossPrice)}
                    {/if}
                </div>
            {/if}
        </div>
    {/if}
    {#if retailPrice || retailPriceGross}
        <div class="tablerow">
            <div class="col alignleft small">{$_("positions.RRP")}</div>
            <div class="col alignright small nowrap">
                {#if retailPrice}
                    {moneyFormat(retailPrice)}
                {/if}
            </div>
            {#if isOut()}
                <div class="col alignright small nowrap">
                    {#if retailPriceGross}
                        {moneyFormat(retailPriceGross)}
                    {/if}
                </div>
            {/if}
        </div>
    {/if}
    {#if endCustomerPrice || endCustomerPriceGross}
        <div class="tablerow">
            <div class="col alignleft small">{$_("positions.endcustomer")}</div>
            <div class="col alignright small nowrap">
                {#if endCustomerPrice}
                    {moneyFormat(endCustomerPrice)}
                {/if}
            </div>
            {#if isOut()}
                <div class="col alignright small nowrap">
                    {#if endCustomerPriceGross}
                        {moneyFormat(endCustomerPriceGross)}
                    {/if}
                </div>
            {/if}
        </div>
    {/if}
    {#if endCustomerPriceGross}
        <div class="tablerow">
            <div class="col alignleft small">
                {$_("positions.margin")} ({(
                    Math.round(((endCustomerPrice - netPrice) / endCustomerPrice) * 100 * 100) / 100
                ).toFixed(2)}%)
            </div>
            <div class="col alignright small nowrap">
                {moneyFormat(endCustomerPrice - netPrice)}
            </div>
            {#if isOut()}
                <div class="col alignright small nowrap">
                    {#if endCustomerPriceGross && grossPrice}
                        {moneyFormat(endCustomerPriceGross - grossPrice)}
                    {/if}
                </div>
            {/if}
        </div>
    {/if}
</div>
